import { useEffect } from 'react';

import { PaymentActionType } from '../../../../components/transaction/Payment/form/actions';
import * as usePaymentFormContext from '../../../../components/transaction/Payment/form/useFormContext';
import type { TransactionActor } from '../../../../generated-types';
import { useActorReceiver } from '../../../../hooks/useSetReceiver';

export const useOutboxFormContext = usePaymentFormContext.default;

export const useConfigureReceiverAccount = (actor: TransactionActor) => {
    const { handleChange } = useOutboxFormContext();

    const actorReceiver = useActorReceiver(actor);

    useEffect(() => {
        if (actorReceiver) {
            handleChange({
                type: PaymentActionType.TO_ACCOUNT_SELECTED,
                payload: actorReceiver,
            });
        }
    }, [handleChange, actorReceiver]);
};
